export default {
  SHIPPING: 'shipping'
};